import { useQuery } from 'react-query';
import getPrinterStatus from 'data/requests/getPrinterStatus';
import { PrinterStatus } from 'model/pinterStatus';

const usePrinterStatus = () => {
  const { data, isLoading } = useQuery<PrinterStatus>(
    'printer-status',
    getPrinterStatus,
  );

  return { printerStatus: data, isLoading };
};

export default usePrinterStatus;
